module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/unknown-14a4ae1a8353de5ec1f1235e521cfda1.png";